import { createFileRoute } from '@tanstack/react-router'
import { CredentialView } from '@/components/sections/credentials'

export const Route = createFileRoute('/_protected/_rest/credentials/$credentialId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { credentialId } = Route.useParams()

  return (
    <div className="h-full p-4 md:px-10 md:py-6">
      <div className="mx-auto flex h-full w-full flex-col gap-y-8">
        <CredentialView credentialId={credentialId} />
      </div>
    </div>
  )
}
